package kz.dentalcrm.app.data

import kz.dentalcrm.app.core.utils.Result
import kz.dentalcrm.app.data.network.InitialInspectionApi
import kz.dentalcrm.app.data.network.request_model.InitialInspectionRequest
import kz.dentalcrm.app.data.network.response_model.initial_inspection.InitialInspectionType
import kz.dentalcrm.app.domain.InitialInspectionRepository

class InitialInspectionRepositoryImpl(
    private val initialInspectionApi: InitialInspectionApi
) : InitialInspectionRepository {

    override suspend fun getInitialInspections(appointmentId: Int): Result<List<InitialInspectionType>> {
        return initialInspectionApi.getInitialInspections(appointmentId)
    }

    override suspend fun toggleInspection(
        appointmentId: Int,
        inspectionTypeId: Int,
        inspectionOptionId: Int,
        isChecked: Boolean
    ): Result<Any?> {
        val request = InitialInspectionRequest(
            appointmentId = appointmentId.toString(),
            inspectionTypeId = inspectionTypeId,
            inspectionOptionId = inspectionOptionId,
            isChecked = if (isChecked) 1 else 0
        )
        return initialInspectionApi.toggleInitialInspection(request)
    }

    override suspend fun addCustomInspection(
        appointmentId: Int,
        inspectionTypeId: Int,
        value: String
    ): Result<Any?> {
        val request = InitialInspectionRequest(
            appointmentId = appointmentId.toString(),
            inspectionTypeId = inspectionTypeId,
            inspectionOptionId = null,
            isChecked = 1,
            isCustom = 1,
            value = value
        )
        return initialInspectionApi.toggleInitialInspection(request)
    }
}
